import { Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import * as yup from "yup";
import FormikTextField from "../../components/Forms/FormikTextField";
import LoaderButton from "../../components/LoaderButton";
import { Constants } from "../../libs/Constants";
import { delObj } from "../../libs/dbFunctions";

const schema = yup.object({
  email: yup
    .string()
    .required("A valid email is required")
    .email("A valid email is required"),
});
export const DeleteUser = (props) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (props.object) {
      setUser(props.object);
    }
  }, [props.object]);

  const handleSubmit = async (values, { setSubmitting }) => {
    if (values.email !== user.email) {
      toast.error("Unable to delete user. Email address does not match. Please re-enter.");
      return;
    }
    setSubmitting(true);
    try {
      await delObj(Constants.dbTypes.USER, user.id, props.activeCompany.id);
      toast.success("User deleted successfully.");
      props.onHide();
    } catch (e) {
      if (e.response && e.response.data && e.response.data.error) {
        toast.error(e.response.data.error);
      } else {
        toast.error(e);
      }
    }
    setSubmitting(false);
  };
  return (
    <React.Fragment>
      <Modal.Header className="p-4" closeButton>
        <Modal.Title>Confirm user email address</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {!user && <>Loading...</>}
        {user && (
          <Formik
            validationSchema={schema}
            onSubmit={handleSubmit}
            initialValues={{
              email: "",
            }}
          >
            {({ isValid, isSubmitting }) => (
              <Form className="w-100 p-5">
                <FormikTextField
                  size="md"
                  controlId="email"
                  label="Email"
                  type="text"
                  name="email"
                  className="mb-4"
                />
                <LoaderButton
                  block
                  type="submit"
                  variant="primary"
                  size="lg"
                  text="Confirm"
                  className="mb-2"
                  disabled={!isValid || isSubmitting}
                >
                  Confirm
                </LoaderButton>
              </Form>
            )}
          </Formik>
        )}
      </Modal.Body>
    </React.Fragment>
  );
};
